// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoggingService } from '../../services/logging.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private injector: Injector) { }

    handleError(error: any): void {
        try {
            // Lazy injection to avoid circular dependency
            const loggingService = this.injector.get(LoggingService);
            const err = error instanceof Error ? error : new Error(error?.toString() || 'Unknown Error');

            loggingService.logException(err);
        } catch (loggingError) {
            console.error('Error logging exception in GlobalErrorHandler:', loggingError);
        }

        // Always log to console for development visibility
        console.error(error);
    }
}
